import { observer } from 'mobx-react-lite';
import { closeTabAriaLabel } from 'owa-locstrings/lib/strings/closetabarialabel.locstring.json';
import { messageIsSendingTitle, messageIsSentTitle } from './ComposeTab.locstring.json';
import { messageSendingFailTitle } from 'owa-locstrings/lib/strings/messagesendingfailtitle.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import getFriendlySubject from 'owa-mail-compose-actions/lib/utils/getFriendlySubject';

import { AsyncSendState, getStore } from 'owa-mail-compose-store';
import { ComposeTabViewState, lazyCloseTab } from 'owa-tab-store';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';
import { IconButton } from '@fluentui/react/lib/Button';
import { Spinner } from '@fluentui/react/lib/Spinner';

const styles = require('./ComposeTab.scss');
const classNames = require('classnames');

export interface ComposeTabProps {
    viewState: ComposeTabViewState;
    className: string;
    subjectClassName: string;
}

export default observer(function ComposeTab(props: ComposeTabProps) {
    const onClickCloseButton = (e: React.MouseEvent<unknown>) => {
        e.stopPropagation();
        lazyCloseTab.importAndExecute(props.viewState);
    };
    const { viewState, className, subjectClassName } = props;
    const composeStore = getStore();
    const composeViewState = composeStore.viewStates.get(viewState.data);
    if (!composeViewState) {
        return null;
    }
    const subject = getFriendlySubject(composeViewState.subject);
    switch (composeViewState.asyncSendState) {
        case AsyncSendState.Timeout:
            return (
                <div className={className} title={subject}>
                    <Spinner className={styles.leftIcon} />
                    <div className={subjectClassName}>{loc(messageIsSendingTitle)}</div>
                </div>
            );
        case AsyncSendState.Error:
            return (
                <div className={className} title={subject}>
                    <Icon
                        iconName={ControlIcons.Error}
                        className={classNames(styles.leftIcon, styles.error)}
                    />
                    <div className={subjectClassName}>{loc(messageSendingFailTitle)}</div>
                </div>
            );
        case AsyncSendState.Sent:
            return (
                <div className={className} title={subject}>
                    <Icon
                        iconName={ControlIcons.CheckMark}
                        className={classNames(styles.leftIcon, styles.checkmark)}
                    />
                    <div className={subjectClassName}>{loc(messageIsSentTitle)}</div>
                </div>
            );
        default:
            return (
                <div className={className} title={subject}>
                    <Icon iconName={ControlIcons.Edit} className={styles.leftIcon} />
                    <div className={subjectClassName}>{subject}</div>
                    <IconButton
                        iconProps={{ iconName: ControlIcons.Cancel }}
                        onClick={onClickCloseButton}
                        className={styles.rightIcon}
                        aria-label={loc(closeTabAriaLabel)}
                    />
                </div>
            );
    }
});
